//estilos para Select - React

export const customStyles = {
    control: base => ({
      ...base,
      height: "20px",
      minHeight: "20px",
      width: "200px",
      fontSize: "10pt",     
      color: "#f97316",
      backgroundColor: " #212f3c ",            
    }),
    placeholder: base => ({
      ...base,
      color: "#f97316",
      paddingBottom: 2
    }),
    option: (base, {isFocused}) => ({
        ...base,
        height: "20px",
        minHeight: "20px",
        width:"300px",
        fontSize: "8pt",
        paddingTop: 3,
        //background: " #212f3c ",
        backgroundColor: isFocused ? ' #566573 ' : '#212f3c'                
      }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "20px",
        color: "#f97316",
        //padding: '0 6px'
      }),
    dropdownIndicator: (styles) => ({
        ...styles,
        paddingTop: 1,
        paddingBottom: 1,
    }),
    clearIndicator: (styles) => ({
        ...styles,
        paddingTop: 5,
        paddingBottom: 5,        
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '20px',
      }),
    singleValue: (state) => ({
      ...state,
      color: "#f97316"
    }),
    input: (style) => ({
      ...style,
      color: "#f97316"
    })
  };

  export const customStylesItems = {
    control: base => ({
      ...base,
      height: "20px",
      minHeight: "20px",
      width: "340px",
      fontSize: "10pt",
      //fontColor: "#f39c12",
      background: " #212f3c "
    }),
    placeholder: base => ({
      ...base,
      color: "#f97316",
      paddingBottom: 2
    }),
    option: (base, {isFocused}) => ({
        ...base,
        height: "20px",
        minHeight: "20px",
        width:"650px",
        fontSize: "8pt",
        paddingTop: 3,
        //background: " #212f3c ",
        backgroundColor: isFocused ? ' #566573 ' : '#212f3c'
      }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "20px",
        //padding: '0 6px'
      }),
    dropdownIndicator: (styles) => ({
        ...styles,
        paddingTop: 1,
        paddingBottom: 1,
    }),
    clearIndicator: (styles) => ({
        ...styles,
        paddingTop: 5,
        paddingBottom: 5,
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '20px',
      }),
      singleValue: (state) => ({
        ...state,
        color: "#f97316"
      }),
    input: (style) => ({
      ...style,
      color: "#f97316"
      })
  };

  export const customStylesCoeficiente = {
    control: base => ({
      ...base,
      height: "20px",
      minHeight: "20px",
      width: "130px",
      fontSize: "10pt",     
      color: "#f97316",
      backgroundColor: " #212f3c ",            
    }),
    placeholder: base => ({
      ...base,
      color: "#f97316",
      paddingBottom: 2
    }),
    option: (base, {isFocused}) => ({
        ...base,
        height: "20px",
        minHeight: "20px",
        width:"80px",
        fontSize: "8pt",
        paddingTop: 3,
        //background: " #212f3c ",
        backgroundColor: isFocused ? ' #566573 ' : '#212f3c'                
      }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "20px",
        color: "#f97316",
        //padding: '0 6px'
      }),
    dropdownIndicator: (styles) => ({
        ...styles,
        paddingTop: 1,
        paddingBottom: 1,
    }),
    clearIndicator: (styles) => ({
        ...styles,
        paddingTop: 5,
        paddingBottom: 5,        
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '20px',
      }),
    singleValue: (state) => ({
      ...state,
      color: "#f97316"
    }),
    input: (style) => ({
      ...style,
      color: "#f97316"
    })
  };

  